<template>
    <div>
        <div class="container-fluid">
            <div class="row justify-content-md-center">
                <div class="col col-lg-4" v-show="choice_1">
                    <div v-show="!loader" class="row justify-content-md-center">
                        <p class="text-center d-md-block" id="mercidepot">
                            Merci d'avoir déposé vos informations que nous lirons avec attention.
                            <br />
                            Je vous propose de vous appeler le :
                             </p>
                    </div>

                    <div id="choice_1" >
                        <div class="text-center"><loader v-show='loader'  message="Collecte des créneaux disponibles en cours..."></loader></div>
                        <div v-show="!loader">
                            <p class="text-center" id="earlyslot"><span>{{earlyslot.date}}</span></p>
                            
                            <p id="validation_earlyslot" class="text-center"><button v-on:click="confirm_slot(earlyslot.ts)"><font-awesome-icon icon="mouse-pointer" /> Cliquez-ici pour confirmer ce RDV</button></p>
                            <p id="refus_earlyslot" class="text-center"><button v-on:click="set_choice('choice_2')">Voir d'autres propositions</button></p>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-8" v-show="choice_2">
                    <p class="text-center" id="autrecreneau" v-show='!loader'>Cliquez sur le créneau qui vous convient :</p>
                    <div id="choice_2">
                        <div class="text-center"><loader v-show='loader' message="Enregistrement du créneau choisi en cours..."></loader></div>
                        <div v-show="!loader">
                            <div class="row">
                                <div class="col col-lg-4 col-12 datetime" v-for="(slots, index) in proposedslots" :key="slots.index">
                                    <div class="col col-12">
                                        <span class="proposeddate">{{slots.date}}</span>
                                    </div>
                                    <!--<div class="col col-12 text-center listts" v-if="slots.times.length==0">
                                        <div class="ts ts_reserve am" v-if="slots.reserve.am||false" @click="select_slot_reserve($event, slots.date, slots.day,'am')">Le matin {{plages["am"]}}</div>
                                        <div class="ts ts_reserve pm" v-if="slots.reserve.pm||false" @click="select_slot_reserve($event, slots.date, slots.day, 'pm')">L'après midi {{plages["pm"]}}</div>
																		</div>-->
                                    <div class="col col-12 text-center listts" :id="'list_ts_'+index">
                                        <div v-if="slots.times.length>0"><div class="ts" :id="'ts_'+time.ts" v-for="(time, index) in slots.times" :key="time.index" v-b-modal.modal-validation v-on:click="select_slot(time.ts)"  :class="{'d-none':index>9}">{{time.time}}</div></div>
                                       
                                        <button v-if="slots.times.length>10" class="more" v-on:click="more('list_ts_'+index)">+ de créneaux</button>
                                    </div>
                                </div>
                            </div>
                            

                            <!--<p id="nextslots" v-show="nextslots" class="text-center" ><button v-on:click="next_slots('nextslots')">Voir les jours suivants <font-awesome-icon class="float-right" icon="arrow-circle-right" /></button></p>-->
                            <div class="text-center"><loader v-show='loader_nextslots'></loader></div>
                            <p id="refus_proporedslot" class="text-center" >
                                Aucun des créneaux proposés ne vous convient ?<br /><br />
                                <button v-on:click="refuse_slot(false)">Je souhaite être appelé pour convenir d'un RDV</button>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-8" v-show="choice_3">
<p id="refus_proporedslot2" class="text-center" >
<strong>Aïe, tous nos chargés de recrutement sont occupés pour le moment…</strong>
<span>Si vous le souhaitez, je vous appelle pour convenir d'un RDV directement par téléphone.</span>
<button v-on:click="refuse_slot(false)">OK, je souhaite être rappelé(e)</button>
         </p>
								</div>
                <!--<div class="col col-lg-4">
                    <h4 class="text-center">Je définis moi-même une date</h4>
                    <div id="choice_3" v-show="choice_3">
                        
                    </div>
                </div>-->
            </div>
        </div>
        <b-modal id="modal-validation" ref="modal-validation" title="Valider votre créneau" ok-only cancel="Annuler" ok-title="Choisir un autre créneau">
            <p id="selected_datetime" v-show="selected_datetime" class="text-center" >{{selected_datetime}}</p>
            <p id="validation_proporedslot" class="text-center" ><button v-on:click="confirm_slot(false)">Cliquez-ici pour confirmer ce RDV</button></p>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ["id_contact", "telephone", "nom", "prenom", "uemail"],
    methods: {
        more: function (ts_index) {
            var tss = document.getElementById(ts_index).getElementsByClassName("ts")
            for (var i = 0; i < tss.length; i++) {
                tss[i].classList.remove("d-none")
            }
            document.getElementById(ts_index).getElementsByTagName("button")[0].classList.add("d-none")
        },
        refuse_slot: function () {
            this.$emit('updatemercirappel', false)
        },
        set_choice: function (_choice) {
            var choice = _choice
            this.choice_1 = false
            this.choice_2 = false
            this.choice_3 = false
            this[choice] = true
        },
        confirm_slot: function (slot) {
            this.$refs['modal-validation'].hide()
            var instance = this
            this.loader = true
            var date
            if (!slot) {
                if (this.reserve == false) {
                    date = document.getElementsByClassName("proposeddate active")[0].innerText + " à " + document.getElementsByClassName("ts active")[0].innerText
                    if (document.getElementsByClassName("ts active").length > 0) {
                        slot = document.getElementsByClassName("ts active")[0].id.replace("ts_","")
                    } else {
                        alert("Vous avez omis de sélectionner un créneau")
                        return false
                    }
                } else {
                    date = this.reserve_date + ", " + this.plages[this.reserve_plage]
                    if (this.reserve_day) {
                        slot = new Date(this.reserve_day).getTime() / 1000
                    } else {
                        alert("Vous avez omis de sélectionner un créneau")
                        return false
                    }
                }
            } else {
                date = document.getElementById("earlyslot").innerText
            }
            slot = parseInt(slot)
            var payload = new FormData()
            payload.append('slot', slot)
            payload.append('email', this.email)
            payload.append('telephone', this.telephone)
            payload.append('nom', this.d_nom)
            payload.append('prenom', this.d_prenom)
            payload.append('id_contact', this.id_contact)
            payload.append('reserve', this.reserve)
            if (this.reserve_plage) {
                payload.append('reserve_plage', this.reserve_plage)
            }
            var xhr = new XMLHttpRequest()
            xhr.open(
                'POST',
                this.access_point + '/setslot',
                true
            )
            xhr.onreadystatechange = function () {
                if (this.readyState === XMLHttpRequest.DONE) {
                    if (this.status === 200) {
                        var response = JSON.parse(xhr.responseText)
                        if (response["success"] == true) {
                            instance.$emit('updatesetrt', date)
                        } else {
                            instance.loader = false
                            alert(response["message"])
                        }
                    } else {
                        alert("Une erreur est survenue ! ")
                        instance.loader = false
                    }
                }
            }
            xhr.send(payload)
        },
        select_slot_reserve: function (event, date, day, plage) {
            this.reserve = true
            this.reserve_date = date
            this.reserve_day = day
            this.reserve_plage = plage
            var ts_reserves = document.getElementsByClassName("ts_reserve")
            for ( var i = 0; i < ts_reserves.length; i++ ) {
                ts_reserves[i].classList.remove("active")
            }
            event.target.classList.add("active")
           
            this.selected_datetime = "Vous avez choisi le " + date + ", " + this.plages[plage]
            this.choice_2_button = true
            this.$refs['modal-validation'].show()
        },
        select_slot: function (ts) {
            this.reserve = false
            var tss = document.getElementsByClassName("ts")
            this.selected_datetime = "Vous avez choisi "
            for (var i = 0; i < tss.length; i++) {
                if (tss[i].id == "ts_" + ts) {
                    tss[i].classList.add("active") 
                 } else {
                    tss[i].classList.remove("active")
                 }
            }
            var datetime = document.getElementsByClassName("datetime")
            var current
            for (i = 0; i < datetime.length; i++) { 
                current = datetime[i].getElementsByClassName("proposeddate")[0]
                if (datetime[i].getElementsByClassName("ts active").length > 0) {
                    current.classList.add("active")
                } else {
                    current.classList.remove("active")
                } 
            }
            this.selected_datetime = "Vous avez choisi " + document.getElementsByClassName("proposeddate active")[0].innerText + " à " + document.getElementsByClassName("ts active")[0].innerText
            this.choice_2_button = true
            this.$refs['modal-validation'].show()
            return true
        },
        next_slots: function (route) {
            var instance = this
            if (route == "nextslots") {
                this.nextslots = false 
                this.loader_nextslots = true 
            } else {
                instance.loader = true
            } 
            var xhr = new XMLHttpRequest()
            xhr.open(
                'POST',
                this.access_point + '/' + route,
                true
            )
            xhr.onreadystatechange = function () {
                if (this.readyState === XMLHttpRequest.DONE) {
                    instance.slots = JSON.parse(xhr.responseText);
										
										// on vire la'ganda lapin si aucun créseau
									let cs=0
									instance.slots.forEach((s)=>{ cs+=s.slots.length})
									if(cs==0) {
										instance.set_choice('choice_3')
										return
									}


                    var date = false
                    var ts = false
                    if (instance.slots[0]["slots"].length > 0) {
                        date = instance.slots[0]["slots"][0]["start"]["date"]
                        ts = instance.slots[0]["slots"][0]["start"]["ts"]
                    } else if (instance.slots.length == 2 && instance.slots[1]["slots"].length > 0){
                        date = instance.slots[1]["slots"][0]["start"]["date"]
                        ts = instance.slots[1]["slots"][0]["start"]["ts"]
                    } else if (instance.slots.length > 2 && instance.slots[2]["slots"].length > 0) {
                        date = instance.slots[2]["slots"][0]["start"]["date"]
                        ts = instance.slots[2]["slots"][0]["start"]["ts"]
                    }

                    instance.earlyslot = {
                        "date": date,
                        "ts": ts,
                    }
                    
                    instance.loader = false
                    instance.loader_nextslots = false
                    var nb_next_day = instance.slots.length
                    var nb_next_time = 100
                    var iter_next_day = 0
                    
                    while (iter_next_day < nb_next_day) {
     
                        if ( instance.slots[iter_next_day]["slots"].length > 0 || instance.slots[iter_next_day]["reserve"]["am"] == true || instance.slots[iter_next_day]["reserve"]["pm"] == true) {
         
                            var _date
                            if (instance.slots[iter_next_day]["slots"] == false) {
                                _date = instance.friendly_date(instance.slots[iter_next_day]["day"])
                            } else {
                                _date = instance.slots[iter_next_day]["slots"][0]["start"]["date"].split("à")[0].trim()
                            }
                            var proposedslots = {
                                "date" : _date,
                                "day": instance.slots[iter_next_day]["day"],
                                "reserve": instance.slots[iter_next_day]["reserve"],
                                "times": []
                            }
														// si il est midi passé, on vire le matin
														if(new Date() > new Date(proposedslots.day).setHours(12,0,0,0)) proposedslots.reserve.am=false

                            for (var i=0; i < nb_next_time; i++) {
                                if (i < instance.slots[iter_next_day]["slots"].length) {
                                    proposedslots["times"].push({
                                        "time": instance.slots[iter_next_day]["slots"][i]["start"]["date"].split("à")[1],
                                        "ts": instance.slots[iter_next_day]["slots"][i]["start"]["ts"],
                                        "selected": false
                                    })
                                } 
                            }
                            instance.proposedslots.push(proposedslots)
                        }
                        
                        iter_next_day++
                    }
                    if (instance.earlyslot.date == false) {
                        instance.set_choice('choice_2')
                    }
                }
            }
            xhr.send()
        },
        friendly_date (date) {
            var jours = new Array("dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi")
            var mois = new Array("janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre")
            var _date = new Date(date)
            var day = _date.getDay()
            var month = _date.getMonth()
            return jours[day] + " " + _date.getDate() + " " + mois[month]
        }
    },
    mounted () {
        this.phone = this.telephone
        this.d_nom = this.nom
        this.d_prenom = this.prenom
        this.next_slots("slots")
    },
    data () {
        return {
            //access_point: "http://192.168.56.1:8000",
            //access_point: window.location.hostname == "localhost" ? "http://192.168.56.1:8020" : "https://trzqx759831.aprkop.com",
            access_point: "https://trzqx759831.aprkop.com",
            email: this.uemail,
            phone: '',
            d_nom: '',
            d_prenom: '',
            selected_datetime: '',
            loader: true,
            slots: false,
            earlyslot: false,
            nextslots: true,
            loader_nextslots: false,
            proposedslots: [],
            choice_1: true,
            choice_2: false,
            choice_3: false,
            choice_2_button: false,
            reserve: false,
            reserve_date: false,
            reserve_day: false,
            reserve_plage: false,
            plages : {
                "am": "entre 10h et 12h",
                "pm": "entre 14h et 16h"
            }
        }
    }
} 
</script>

<style lang="less">
    div.datetime {
        margin-bottom: 20px;
    }
    #mercidepot, #autrecreneau {
        margin-top:100px;
        font-size:18px;
        font-weight: bold;
    }
    h2 {
        color: #0b73b0;
        font-weight: bold;
        padding-top:40px;
        padding-bottom:60px;
        font-size:30px;
        display:block;
    }

    button.more {
        border:none;
        background: none;
        text-align: center;
        font-weight: bold;
        font-size: 15px;
        color:#999;
        padding:10px 0;
        width:100%;
        &:hover {
            background: #085a8a;
            color:white;
        }
    }

    h4 {
        color: #000000;
        font-weight:bold;
        font-size:25px;
        padding:10px;
        cursor: pointer;
        font-weight: bold;
    }

    p#earlyslot {
        font-size: 26px;
        color: #0b73b0;
        margin: 0px 0 0 0;
        font-weight: bold;
        padding: 18px;
    }

    p#validation_earlyslot button {
        box-shadow: 0 0 10px 0 rgba(0,0,0,0.5);
        border:1px solid #4ec34a;
        background: #4ec34a;
        text-align: center;
        font-weight: bold;
        font-size: 25px;
        color:white;
        padding:20px 0;
        width:100%;
        &:hover {
            border:1px solid #085a8a;
            background: #085a8a;
            color:white;
        }
    }
    p#refus_proporedslot {
        margin-top:40px;
    }
    p#refus_proporedslot2 {
        margin-top:40px;
				strong { color: #1478bc; font-weight:bold;display:block}
				span { display:block;margin-top: 20px; margin-bottom: 30px;}
    button {
        border: none;
        background: #1478BD;
				color: #fff;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        padding:20px 0;
        width:60%;
				margin-bottom: 200px;
        &:hover {
            background: #085a8a;
            color:white;
        }
    }
		}


    p#refus_earlyslot button {
        border: none;
        background: #f3f3f3;
        text-align: center;
        font-weight: bold;
        font-size: 20px;
        padding:20px 0;
        width:100%;
        &:hover {
            background: #085a8a;
            color:white;
        }
    }

    p#refus_proporedslot button {
        border: none;
        background: #ffffff;
        color:black;
        text-align: center;
        text-decoration: none;
        font-size: 15px;
        padding:20px 0;
        width:100%;
        &:hover {
            background: #085a8a;
            color:white;
        }
    }

    p#validation_proporedslot button {
        border: none;
        background: #4ec34a;
        padding: 24px 100px;
        text-align: center;
        width: 100%;
        padding:20px 0;
        font-weight: bold;
        font-size: 25px;
        margin-top:10px;
        color:white;
        &:hover {
            background: #085a8a;
        }
        svg{
            margin-right: 15px;
            margin-top: 5px;
        }
    }

    p#nextslots button {
        border: none;
        background: #0b73b0;
        padding: 24px 100px;
        text-align: center;
        width: 100%;
        padding:20px 0;
        font-weight: bold;
        font-size: 25px;
        margin-top:10px;
        color:white;
        svg{
            margin-right: 15px;
            margin-top: 5px;
        }
        &:hover {
            background: #085a8a;
        }
    }

    span.proposeddate {
        padding: 15px 25px;
        background: #a5a5a5;
        color: white;
        font-weight: bold;
        min-width:280px;
        display:block;
        text-align: center;
    }

    #choice_2 ul {
        padding: 0;
        margin: 0;
    }

    #choice_2>div>ul>li{
        margin-top:10px;
        padding-bottom:10px;
        border-bottom:1px dotted #cccccc;
    }

    div.proposedtimes {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    div.listts {
        margin-top:2px;
    }

    div.ts_reserve {
        width: 100%;
    }

    div.ts{
        margin: 0 2px 2px 0;
        background: #f3f3f3;
        padding: 15px 13px;
        display:inline-block;
        text-align: center;
        cursor: pointer;
        min-width: 87px;
        &:hover {
            background: #0b73b0;
            color:white;
        }
        &.active {
            background: #0b73b0;
            color:white;
        }
    }
    

    span.proposeddate.active {
        background: #0b73b0;
        color:white;
    }

    #selected_datetime {
        font-weight: bold;
    }

    #bloc_validation {
        background: #f4f4f4;
    }

</style>
